<div #wrapper class="view-recipe-wrapper">
    <app-modal-header [text]="('copy_recipe' | localise) + ' - Advanced'" [bold]="true" (close)="bsModalRef.hide()"></app-modal-header>

    <div class="modal-body" [ngClass]="isIOS() === true ? 'ios' : ''">
        <h2 class="title-bg">{{ 'copy_to_days' | localise }} - Advanced</h2>

        <ul class="dates">
            <li *ngFor="let date of dates; let i = index">
                <div class="form-group">
                    <div class="form-check">
                        <label class="form-check-label">
                            <input
                                    class="form-check-input"
                                    name="date"
                                    type="checkbox"
                                    (click)="markDayAsSelected(date.date)"
                                    value="">
                            {{ date.date }} ({{ date.week_name }})
                            <i class="input-helper"></i>
                        </label>
                    </div>
                </div>
            </li>
        </ul>

        <h2 class="title-bg">Копирай избраните дни в интервал (включително):</h2>

        <div class="row">
            <div class="col-12 stretch-card">
                <div class="col-6 no-padding" style="padding-right: 10px !important;">
                    {{ 'from' | localise }}<br/>
                    <angular2-date-picker
                            (onDateSelect)="onStartDateChange($event)"
                            [(ngModel)]="fromDate"
                            [settings]="settings"></angular2-date-picker>
                </div>
                <div class="col-6 no-padding" style="padding-left: 10px !important;">
                    {{ 'to' | localise }}<br/>
                    <angular2-date-picker
                            (onDateSelect)="onToDateChange($event)"
                            [(ngModel)]="toDate"
                            [settings]="settings"></angular2-date-picker>
                </div>
            </div>
        </div>
    </div>

    <div class="modal-footer" [ngClass]="isIOS() === true ? 'ios' : ''">
        <button type="button" class="btn btn-secondary" (click)="bsModalRef.hide()">{{ 'back' | localise }}</button>
        <button type="button" class="btn btn-success" (click)="copyRecipe()">{{ 'copy_btn' | localise}}</button>
    </div>
</div>
